import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PromoNavigationContainer from '../../containers/promo-navigation-container';

import PromoNavigationItem from '../../containers/promo-navigation-item';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const PromoNavigationContainerBlock = props => <PromoNavigationContainer {...props} />;
PromoNavigationContainerBlock.displayName = 'PromoNavigationContainer';

export default withDynamicComponents({
  componentWhitelist: [
    PromoNavigationItem,
    Html,
    Wysiwyg,
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(PromoNavigationContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/promo-navigation-container/index.jsx